<div class="card-base-actions">
    <div class="card-content-cash-desk">
        <div class="card-container mat-elevation-z1">
            <div class="card-content">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <div *ngIf="!loading" (resized)="onResized($event)">
                    <iframe class="full-width" height="500" *ngIf="getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>